export default {
    statuses: {
        OPEN: 'В ОЖИДАНИИ',
        OUT_OF_TIME: 'ДЛЯ ПЕРЕНАЗНАЧЕНИЯ',
        ACCEPTED: 'ПРИНЯТО',
        DECLINED: 'ОТКЛОНЕНО',
        CANCELED: 'ОТМЕНЕНО',
        DONE: 'ВЫПОЛНЕНО',
        DONE_BY_CRON: 'ВЫПОЛНЕНО',
        UNAVAILABLE: 'НЕДОСТУПНО',
        NO_SHOW: 'НЕ ПРИШЕЛ',
    },
    actions: {
        ACCEPT: 'ПРИНЯТЬ',
        DECLINE: 'ОТКЛОНИТЬ',
        CANCEL: 'ОТМЕНИТЬ',
        RESCHEDULE: 'ПЕРЕНАЗНАЧИТЬ',
        MAKE_UNAVAILABLE: 'СДЕЛАТЬ НЕДОСТУПНЫМ',
        VIEW: 'ПРОСМОТР',
        UNAVAILABLE: 'ОТМЕНИТЬ И СДЕЛАТЬ ВРЕМЕННЫЙ ИНТЕРВАЛ НЕДОСТУПНЫМ',
        DONE: 'ПОЯВИЛСЯ',
        NO_SHOW: 'НЕ ПРИШЕЛ',
        FINISH: 'ЗАВЕРШИТЬ',
        FINISH_EARLY: 'СОКРАЩЕНИЕ БРОНИРОВАНИЯ',
        REMOVE_FINISH_EARLY: 'УДАЛИТЬ СОКРАЩЕНИЕ БРОНИРОВАНИЯ',
    },

    modal: {
        cancel_heading: 'Вы уверены, что хотите отменить?',
        decline_or_make_unavailable: 'Отклонить или отклонить и сделать временный интервал недоступным?',
        cancel_or_make_unavailable: 'Вы уверены, что хотите отменить бронирование?',
        no_show_headling: 'Пользователь явился на встречу?',
        finish_early_heading: 'Завершить раньше',
        finish_early_description:
            'Настройте время окончания этого события, чтобы позволить последующим бронированиям начинаться раньше. Укажите, сколько минут после начала времени вы будете доступны для следующего бронирования.',
        finish_early_chose: 'Выберите время',
        remove_finish_early_modal: 'Вы уверены, что хотите удалить предыдущее время завершения?',
    },
}
